import isEqual from "lodash.isequal";
import {
  waitForResults,
  getInitialResults
} from "instantsearch.js/es/lib/server";
import { computed, triggerRef, inject, nextTick } from "vue";
import { useState, createError } from "nuxt/app";
export const useInstantSearch = (instance) => {
  const _searchInstance = instance ?? inject("searchInstance");
  const _results = useState(
    "_instantsearch_ssr_results"
  );
  const getInstance = () => {
    if (_searchInstance.value === null) {
      throw new Error("instantiate instantsearch first");
    }
    return _searchInstance;
  };
  const parentIndex = computed(() => {
    return getInstance().value.mainIndex;
  });
  const setup = async (widgets) => {
    const instance2 = getInstance();
    if (!instance2.value.mainIndex.getWidgets().length) {
      instance2.value.addWidgets(widgets);
    } else {
      const oldWidgets = instance2.value.mainIndex.getWidgets();
      const widgetsToAdd = widgets.filter(
        (newW) => !oldWidgets.some(
          // @ts-ignore
          (oldW) => isEqual(oldW.$$widgetParams, newW.$$widgetParams)
        )
      );
      const widgetsToRemove = oldWidgets.filter(
        (oldW) => !widgets.some(
          (newW) => (
            // @ts-ignore
            isEqual(oldW.$$widgetParams, newW.$$widgetParams)
          )
        )
      );
      if (widgetsToRemove.length)
        instance2.value.removeWidgets(widgetsToRemove);
      if (widgetsToAdd.length)
        instance2.value.addWidgets(widgetsToAdd);
    }
    if (!instance2.value.started && !_results.value) {
      instance2.value.start();
      instance2.value.started = false;
      const params = await waitForResults(instance2.value);
      _results.value = getInitialResults(instance2.value.mainIndex, params);
    }
    if (!_results.value && import.meta.client) {
      await nextTick(async () => {
        await new Promise((resolve) => {
          if (!instance2.value.mainHelper.hasPendingRequests())
            resolve(true);
          instance2.value.mainHelper.once(
            "searchQueueEmpty",
            () => resolve(true)
          );
        });
      });
    }
    if (_results.value && import.meta.client) {
      instance2.value._initialResults = _results.value;
      _results.value = null;
    }
    if (!instance2.value.started && import.meta.client) {
      nextTick(async () => {
        instance2.value.mainHelper?.on("searchQueueEmpty", () => {
          instance2.value.once("render", () => {
            triggerRef(_searchInstance);
          });
        });
      });
      instance2.value.on("error", ({ error }) => {
        throw createError({
          statusCode: 500,
          statusMessage: error
        });
      });
      instance2.value.start();
    }
  };
  return {
    getInstance,
    parentIndex,
    setup
  };
};
